class BlogListCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = null;
    this.prevButtons = [];
    this.nextButtons = [];
    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleMediaLoad = this.handleMediaLoad.bind(this);
  }

  connectedCallback() {
    this.track = this.querySelector('[data-blog-track]');
    this.prevButtons = Array.from(this.querySelectorAll('[data-blog-prev]'));
    this.nextButtons = Array.from(this.querySelectorAll('[data-blog-next]'));

    this.prevButtons.forEach((button) => button.addEventListener('click', this.handlePrevClick));
    this.nextButtons.forEach((button) => button.addEventListener('click', this.handleNextClick));
    this.track?.addEventListener('scroll', this.handleScroll, { passive: true });
    this.querySelectorAll('img').forEach((image) => image.addEventListener('load', this.handleMediaLoad));
    window.addEventListener('resize', this.handleResize);
    this.updateControls();
  }

  disconnectedCallback() {
    this.prevButtons.forEach((button) => button.removeEventListener('click', this.handlePrevClick));
    this.nextButtons.forEach((button) => button.removeEventListener('click', this.handleNextClick));
    this.track?.removeEventListener('scroll', this.handleScroll);
    this.querySelectorAll('img').forEach((image) => image.removeEventListener('load', this.handleMediaLoad));
    window.removeEventListener('resize', this.handleResize);
  }

  handlePrevClick() {
    this.scrollByCard(-1);
  }

  handleNextClick() {
    this.scrollByCard(1);
  }

  handleScroll() {
    this.updateControls();
  }

  handleResize() {
    this.updateControls();
  }

  handleMediaLoad() {
    this.updateControls();
  }

  scrollByCard(direction) {
    const firstItem = this.track?.querySelector('.blog-list__item');

    if (!this.track || !firstItem) {
      return;
    }

    const cards = this.track.querySelector('.blog-list__cards');
    const cardsStyles = cards ? window.getComputedStyle(cards) : window.getComputedStyle(this.track);
    const gap = Number.parseFloat(cardsStyles.columnGap || cardsStyles.gap || '0');
    const distance = firstItem.getBoundingClientRect().width + gap;
    this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    window.requestAnimationFrame(() => this.updateControls());
  }

  updateControls() {
    if (!this.track || (!this.prevButtons.length && !this.nextButtons.length)) {
      return;
    }

    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const currentScroll = this.track.scrollLeft;
    const hasOverflow = maxScroll > 1;

    const prevDisabled = !hasOverflow || currentScroll <= 1;
    const nextDisabled = !hasOverflow || currentScroll >= maxScroll - 1;

    this.prevButtons.forEach((button) => (button.disabled = prevDisabled));
    this.nextButtons.forEach((button) => (button.disabled = nextDisabled));
  }
}

if (!customElements.get('blog-list-carousel')) {
  customElements.define('blog-list-carousel', BlogListCarousel);
}